'use client'
import React from 'react'
import { Button } from './ui/button'
import { ArrowLeft } from 'lucide-react'
import { useRouter } from 'next/navigation';

const ReturnBack = () => {
    const router = useRouter();

    const handleGoBack = () => {
      router.back(); // Go back to the previous page
    };

    
  return (
    <Button className="mt-5" onClick={handleGoBack}>
        عودة للصفحة السابقة
    </Button>
  )
}

export default ReturnBack